import './PlayerButton.scss';
import { jsx } from 'react/jsx-runtime';

/* External */

function PlayerButton(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children,
    tooltip = _ref.tooltip,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/jsx("button", {
    type: "button",
    title: tooltip,
    className: "dtv-common-c-player-button ".concat(className),
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: children
  });
}
PlayerButton.defaultProps = {
  children: [],
  className: '',
  tooltip: '',
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};

export { PlayerButton as default };
//# sourceMappingURL=PlayerButton.js.map
